<template>
  <a-modal
    title="编辑科室管理/备案"
    :width="900"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleSubmit"
    @cancel="handleCancel"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item v-show="false"><a-input v-decorator="['deptId']" /></a-form-item>
        <a-form-item
          label="医疗机构"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入医疗机构" v-decorator="['orgId', {rules: [{required: true, message: '请输入医疗机构！'}]}]" />
        </a-form-item>
        <a-form-item
          label="医疗科室编码"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入医疗科室编码" v-decorator="['deptCode', {rules: [{required: true, message: '请输入医疗科室编码！'}]}]" />
        </a-form-item>
        <a-form-item
          label="医疗科室名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入医疗科室名称" v-decorator="['deptName', {rules: [{required: true, message: '请输入医疗科室名称！'}]}]" />
        </a-form-item>
        <a-form-item
          label="医疗科室描述"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入医疗科室描述" v-decorator="['deptDesc', {rules: [{required: true, message: '请输入医疗科室描述！'}]}]" />
        </a-form-item>
        <a-form-item
          label="科室位置"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入科室位置" v-decorator="['position']" />
        </a-form-item>
        <a-form-item
          label="电话号码"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入电话号码" v-decorator="['phone']" />
        </a-form-item>
        <a-form-item
          label="科室排序"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入科室排序" v-decorator="['seqno']" />
        </a-form-item>
        <a-form-item
          label="联系人"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入联系人" v-decorator="['linkman']" />
        </a-form-item>
        <a-form-item
          label="创建时间戳"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-date-picker style="width: 100%" placeholder="请选择创建时间戳" v-decorator="['ctstamp',{rules: [{ required: true, message: '请选择创建时间戳！' }]}]" @change="onChangectstamp"/>
        </a-form-item>
        <a-form-item
          label="医疗科室科目编码"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入医疗科室科目编码" v-decorator="['deptClassCode', {rules: [{required: true, message: '请输入医疗科室科目编码！'}]}]" />
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
  import moment from 'moment'
  import { baDepartmentEdit } from '@/api/modular/interhospital/badepartment/baDepartmentManage'
  export default {
    data () {
      return {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 15 }
        },
        ctstampDateString: '',
        visible: false,
        confirmLoading: false,
        form: this.$form.createForm(this)
      }
    },
    methods: {
      moment,
      // 初始化方法
      edit (record) {
        this.visible = true
        setTimeout(() => {
          this.form.setFieldsValue(
            {
              deptId: record.deptId,
              orgId: record.orgId,
              deptCode: record.deptCode,
              deptName: record.deptName,
              deptDesc: record.deptDesc,
              position: record.position,
              phone: record.phone,
              seqno: record.seqno,
              linkman: record.linkman,
              deptClassCode: record.deptClassCode
            }
          )
        }, 100)
        // 时间单独处理
        if (record.ctstamp != null) {
            this.form.getFieldDecorator('ctstamp', { initialValue: moment(record.ctstamp, 'YYYY-MM-DD') })
        }
        this.ctstampDateString = moment(record.ctstamp).format('YYYY-MM-DD')
      },
      handleSubmit () {
        const { form: { validateFields } } = this
        this.confirmLoading = true
        validateFields((errors, values) => {
          if (!errors) {
            for (const key in values) {
              if (typeof (values[key]) === 'object') {
                values[key] = JSON.stringify(values[key])
              }
            }
            values.ctstamp = this.ctstampDateString
            baDepartmentEdit(values).then((res) => {
              if (res.success) {
                this.$message.success('编辑成功')
                this.confirmLoading = false
                this.$emit('ok', values)
                this.handleCancel()
              } else {
                this.$message.error('编辑失败')//  + res.message
              }
            }).finally((res) => {
              this.confirmLoading = false
            })
          } else {
            this.confirmLoading = false
          }
        })
      },
      onChangectstamp(date, dateString) {
        this.ctstampDateString = dateString
      },
      handleCancel () {
        this.form.resetFields()
        this.visible = false
      }
    }
  }
</script>
